var inputIcons = {
    base: {
        color: "black.60",
    },
    variants: {
        position: {
            left: {
                marginRight: "10px",
            },
            right: {
                marginLeft: "10px",
            },
            none: {},
        },
        size: {
            sm: {
                fontSize: "13.14px",
            },
            md: {
                fontSize: "13.14px",
            },
            lg: {
                fontSize: "16.42px",
            },
        },
    },
    defaultProps: {
        size: "md",
        position: "left",
    },
};

export { inputIcons };
//# sourceMappingURL=input-icons.js.map
